// Pinned bottom buttons sit right above the nav, so they share its height.
export const BOTTOM_NAV_HEIGHT = "68px";
